import React from 'react';
import ReactDOM from 'react-dom/client';
import './index.css';
import App from './App';
import reportWebVitals from './reportWebVitals';
import { BrowserRouter } from 'react-router-dom';
import { persistor, store } from './Redux/Store';
import { Provider } from 'react-redux';
import { PersistGate } from 'redux-persist/integration/react';
import "../src/Disablelog";
import { Router } from "react-router-dom"; // 👈 use Router instead
import { unstable_HistoryRouter as HistoryRouter } from "react-router-dom"; // ✅ use this
import { customHistory } from './history';

// import "./firebaseConfig";

// window.onload = () => {
//   if ("serviceWorker" in navigator) {
//     navigator.serviceWorker
//       .register("/firebase-messaging-sw.js")
//       .then((registration) => {
//         console.log("✅ Service Worker registered:", registration);
//       })
//       .catch((error) => {
//         console.error("🚨 Service Worker registration failed:", error);
//       });
//   }
// };



const root = ReactDOM.createRoot(document.getElementById('root'));
root.render(

  <HistoryRouter history={customHistory}>
    <Provider store={store}>
      <PersistGate loading={null} persistor={persistor}>
        <App />
      </PersistGate>
    </Provider>
  </HistoryRouter>


);

// If you want to start measuring performance in your app, pass a function
// to log results (for example: reportWebVitals(console.log))
// or send to an analytics endpoint. Learn more: https://bit.ly/CRA-vitals
reportWebVitals();
